import React from "react";

const Result = ({ isCorrect, correctAnswer, selectedAnswer, options, letter }) => {
  return (
    <div className="result">
      {isCorrect ? (
        <p>
          ✅ Richtig!
          <br />
          Dein nächstes Zeichen ist: {letter}
        </p>
      ) : (
        <p>
          ❌ Falsch. Du hast "{options[selectedAnswer]}" gewählt.
          <br />
          Die richtige Antwort ist: "{options[correctAnswer]}"
        </p>
      )}
    </div>
  );
};

export default Result;
